var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"util-charttitle"},[_c('strong',[_vm._v(_vm._s(_vm.title ?? "Pencatatan Terakhir"))]),_c('router-link',{attrs:{"to":_vm.action}},[_c('button',[_c('img',{attrs:{"src":require("@/assets/img/util-eye.svg")}}),_vm._v(" "),_c('span',[_vm._v("Lihat Semua")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }